import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { picwordService } from '@/services/picword';

export function usePicwordMapList() {
    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: picwordService.map.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute
        }
    });

    const actions = {
        remove: useCrudActions().confirmAndRemove({
            request: picwordService.map.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, query, fetchList, actions };
}
